import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../guard/auth.guard'
import { CocinaComponent } from './cocina.component'
import { DetalleMenuComponent } from './detalle-menu/detalle-menu.component'
import { DetallePlatoComponent } from './detalle-plato/detalle-plato.component'
import { MenusComponent } from './menus/menus.component'
import { PlatosComponent } from './platos/platos.component'
import { SkusComponent } from './skus/skus.component'

const routes: Routes = [
  {
    path: '',
    component: CocinaComponent,
    children: [
      { path: 'menus', canActivate: [AuthGuard], component: MenusComponent },
      { path: 'platos', canActivate: [AuthGuard], component: PlatosComponent },
      { path: 'skus', canActivate: [AuthGuard], component: SkusComponent },
      {
        path: 'detalle-menu/:id',
        canActivate: [AuthGuard],
        component: DetalleMenuComponent
      },
      {
        path: 'detalle-plato/:id',
        canActivate: [AuthGuard],
        component: DetallePlatoComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CocinaRoutingModule {}
